import { AgendaViewEventBase } from './AgendaViewEvent.base';
import type {
    AgendaViewEventProps,
    AgendaViewEventStyleProps,
    AgendaViewEventStyles,
} from './AgendaViewEvent.types';
import { styled } from '@fluentui/react/lib/Utilities';

export type { AgendaViewEventProps };

/** The default style of AgendaViewEvent */
export function getStyles(styleProps: AgendaViewEventStyleProps): AgendaViewEventStyles {
    return {
        root: [
            'ms-AgendaViewEvent',
            styleProps.className,
            {
                display: 'flex',
                height: 'auto',
                margin: '10px 0 20px 0',
            },
        ],
        showAsBar: {
            width: 15,
            height: 15,
            marginTop: 8,
        },
        contentWrapper: {
            marginLeft: 6,
        },
        subjectWrapper: {
            display: 'flex',
        },
        sectionWrapper: {
            marginTop: 10,
        },
        fieldLabel: {
            fontWeight: 'bold',
        },
        fieldData: {
            marginLeft: 4,
        },
        iconWrapper: {
            display: 'flex',
            marginLeft: 4,
            marginBottom: 2,
        },
        subject: {
            fontWeight: 600,
            fontSize: 20,
        },
        timeWrapper: {
            display: 'flex',
            marginBottom: 14,
        },
        bodyWrapper: {
            marginTop: 14,
        },
    };
}

/** The default styled version of AgendaViewEvent */
export const AgendaViewEvent = styled<
    AgendaViewEventProps,
    AgendaViewEventStyleProps,
    AgendaViewEventStyles
>(AgendaViewEventBase, getStyles) as typeof AgendaViewEventBase;
